import request from '@/request'
import doughnut from '@/components/common/DoughnutChart.js'
import dataTablePublic from '@/components/common/DataTablePublic'
import colors from '@/utils/colors.js'
import { exportCSVFile } from '@/utils'
import { PublicHeader } from '../../../components/common'
import { entidadeBySigla } from '@/utils/entidades.js'

export default {
  name: 'PlanosMunicipal',
  components: {
    doughnut,
    dataTablePublic,
    PublicHeader
  },
  data() {
    return {
      texto: {
        'Prioridade+de+Gest%C3%A3o': {
          geral: 'metas',
          concluido: 'meta(s) concluída(s)',
          andamento: 'meta(s) em andamento',
          naoConcluido: 'meta(s) não cumprida(s)',
          analise: 'meta(s) não iniciada(s)'
        },
        'Plano+de+Governo': {
          geral: 'compromissos',
          concluido: 'compromisso(s) concluído(s)',
          andamento: 'compromisso(s) em andamento',
          naoConcluido: 'compromisso(s) não cumprido(s)',
          analise: 'compromisso(s) não iniciado(s)'
        },
        todos: {
          geral: 'metas',
          concluido: 'metas(s) concluída(s)',
          andamento: 'metas(s) em andamento',
          naoConcluido: 'metas(s) não cumprida(s)',
          analise: 'metas(s) não iniciada(s)'
        }
      },
      unidade: '',
      secretarias: [],
      tipoPlanoCodigo: '',
      tiposPlano: [],
      tipoPlanoData: {
        nome: '',
        total: 0,
        concluidoPorcentagem: 0,
        concluido: 0,
        emAndamento: 0,
        naoConcluido: 0,
        indefinido: 0,
        chartData: { labels: [], data: [] }
      },
      rankingConcluidas: [],
      rankingCompromissos: [],
      totais: {
        metas: 0,
        planogoverno: {
          total: 0,
          naoInformado: 0,
          naoConcluido: 0,
          emAndamento: 0,
          concluido: 0
        },
        prioridade: {
          total: 0,
          naoInformado: 0,
          naoConcluido: 0,
          emAndamento: 0,
          concluido: 0
        }
      },
      model: {
        por_status: {
          CONCLUÍDA: 0,
          'EM ANDAMENTO': 0,
          'NÃO INICIADA': 0,
          'NÃO CUMPRIDA': 0
        },
        por_status_secretaria: {},
        rank_compromissos: [],
        total: 0
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        legend: {
          display: true
        },
        plugins: {
          // Change options for ALL labels of THIS CHART
          datalabels: {
            formatter: (value, ctx) => {
              let sum = 0
              let dataArr = ctx.chart.data.datasets[0].data
              dataArr.map(data => {
                sum += data
              })
              let percentage = ((value * 100) / sum).toFixed(2) + '%'
              return percentage
            },
            color: ['#000', '#FFF', '#000', '#FFF', '#FFF', '#FFF', '#000']
          }
        }
      },
      totalStatus: [],
      totalStatusSecretaria: []
    }
  },
  computed: {
    doughnutHeader() {
      return this.gerarGraficoHeader(this.totalStatus)
    },
    doughnutContent() {
      return this.gerarGraficoHeader(this.totalStatusSecretaria)
    },
    doughnutTipoPlano() {
      return this.gerarChartJsDonught(this.tipoPlanoData.chartData)
    },
    link_externo() {
      return (
        'https://egov.santos.sp.gov.br/santosmapeada/Gestao/PlanoMunicipalGoverno/MapaPlanoMunicipalGoverno/montarMapaPlanoMunicipalGoverno/' +
        this.unidade.iduorre
      )
    }
  },
  methods: {
    DownloadJSON2CSV() {
      const headers = {
        indice: ' - ',
        unidade: 'Sigla',
        nome: 'Unidade',
        total: 'Total de Metas',
        concluidas: 'Concluídas',
        percentual: 'Percentual (%)'
      }

      const items = [
        ...this.rankingConcluidas.map((item, index) => {
          return {
            indice: index + 1,
            unidade: item.unidade,
            nome: this.entidadeBySigla(item.unidade),
            total: item.total,
            concluidas: item.concluidas,
            percentual: ((item.concluidas / item.total) * 100)
              .toFixed(2)
              .replace('.', ',')
          }
        })
      ]

      const reducer = (acum, atual) => {
        acum.total += atual.total
        acum.concluidas += atual.concluidas
        return acum
      }

      const totais = this.rankingConcluidas.reduce(reducer, {
        total: 0,
        concluidas: 0
      })

      exportCSVFile(
        headers,
        [
          ...items,
          {
            indice: ' ',
            unidade: ' ',
            nome: 'TOTAL',
            total: totais.total,
            concluidas: totais.concluidas,
            percentual: ((totais.concluidas / totais.total) * 100)
              .toFixed(2)
              .replace('.', ',')
          }
        ],
        'ranking_conclusao'
      )
    },
    retornaSecretaria(sigla) {
      var nome = ''

      switch (sigla) {
        case 'SEAS':
          nome = 'Assistência Social'
          break
        case 'SECID':
          nome = 'Cidadania'
          break
        case 'SERIC':
          nome = 'Relações Institucionais e Cidadania'
          break
        case 'SEFIN':
          nome = 'Finanças'
          break
        case 'SEDURB':
          nome = 'Desenvolvimento Urbano'
          break
        case 'SESERP':
          nome = 'Serviços Públicos'
          break
        case 'SETUR':
          nome = 'Turismo'
          break
        case 'SECULT':
          nome = 'Cultura'
          break
        case 'SEGES':
          nome = 'Gestão'
          break
        case 'SEDUC':
          nome = 'Educação'
          break
        case 'GPM':
          nome = 'Gabinete do Prefeito'
          break
        case 'GVP':
          nome = 'Gabinete do Vice-Prefeito'
          break
        case 'SEGOV':
          nome = 'Governo'
          break
        case 'SEMAM':
          nome = 'Meio Ambiente'
          break
        case 'SMS':
          nome = 'Saúde'
          break
        case 'SEDES':
          nome = 'Desenvolvimento Econômico e Inovação'
          break
        case 'SIEDI':
          nome = 'Infraestrutura e Edificações'
          break
        case 'SECOM':
          nome = 'Comunicação'
          break
        case 'SECOR':
          nome = 'Comunicação e Resultados'
          break
        case 'OTC':
          nome = 'Ouvidoria Transparência e Controle'
          break
        case 'OPM':
          nome = 'Ouvidoria Pública'
          break
        case 'SEPORT':
          nome = 'Assuntos Portuários'
          break
        case 'SAPIC':
          nome = 'Porto, Indústria e Comércio'
          break
        case 'SEMES':
          nome = 'Esportes'
          break
        case 'PGM':
          nome = 'Procuradoria'
          break
        case 'SESEG':
          nome = 'Segurança'
          break
        case 'FAMS-ADM':
          nome = 'Fundação Arquivo e Memória'
          break
        case 'FPTS':
          nome = 'Fundação Parque Tecnológico'
          break
        case 'FUPES':
          nome = 'Fundação Pró-Esporte'
          break
        case 'SEDS':
          nome = 'Desenvolvimento Social'
          break
        case 'SEPLAN':
          nome = 'Planejamento e Inovação'
          break
        case 'SEECTUR':
          nome = 'Empreendedorismo, Economia Criativa e Turismo'
          break
        case 'SAPDC':
        case 'SAPDRC':
        case 'SEPORT-RC':
          nome = 'Assuntos Portuários e Desenvolvimento da Região Central'
          break
        default:
          nome = sigla
          break
      }

      return nome
    },
    gerarGraficoHeader(dados) {
      let labels = []
      let data = []

      dados.forEach(({ tipostatusplano, total }) => {
        labels.push(tipostatusplano)
        data.push(parseInt(total))
      })

      return {
        labels,
        datasets: [
          {
            data,
            backgroundColor: colors.coresRGB,
            borderWidth: 0
          }
        ]
      }
    },
    gerarChartJsDonught({ labels, data }) {
      return {
        labels,
        datasets: [
          {
            data,
            backgroundColor: colors.coresRGB,
            borderWidth: 0
          }
        ]
      }
    },
    loadRankingConcluidas() {
      request.get(
        'planogoverno/ranking-concluidas',
        response => {
          let temp_array = response.data

          const returnPerc = (value, total) => {
            return (value / total) * 100
          }

          const compareNsort = (a, b) => {
            if (
              returnPerc(a.concluidas, a.total) <
              returnPerc(b.concluidas, b.total)
            ) {
              return 1
            }
            if (
              returnPerc(a.concluidas, a.total) >
              returnPerc(b.concluidas, b.total)
            ) {
              return -1
            }
            if (a.total < b.total) {
              return 1
            }
            if (a.total > b.total) {
              return -1
            }
            return 0
          }
          temp_array.sort(compareNsort)

          this.rankingConcluidas = response.data
        },
        response => {
          console.log(response)
        }
      )
    },
    loadRankingCompromissos() {
      request.get(
        'planogoverno/ranking-compromissos',
        response => {
          this.rankingCompromissos = response.data
        },
        response => {
          console.log(response)
        }
      )
    },
    listarSecretarias() {
      request.get(
        'sigsantos/secretarias',
        response => {
          this.secretarias = response.data.map(item => {
            return {
              iduorre: item.iduorre,
              unidaderesponsavel: this.entidadeBySigla(
                item.unidaderesponsavel
              )
            }
          })
        },
        response => {
          console.log(response)
        }
      )
    },
    totalPorTipo() {
      request.get(
        'sigsantos/totalTipo',
        response => {
          let itens = []

          if (response.data.map(({ tipostatusplano }) => tipostatusplano).includes('NÃO INICIADA') === false) {
            itens = response.data
          } else {
            const itemNaoIniciada = response.data.find(i => i.tipostatusplano === 'NÃO INICIADA')
            itens = response.data.filter(i => i.tipostatusplano != 'NÃO INICIADA')
            const indexItemNaoCumprida = itens.findIndex(i => i.tipostatusplano === 'NÃO CUMPRIDA')

            itens[indexItemNaoCumprida].total = parseInt(itens[indexItemNaoCumprida].total) + parseInt(itemNaoIniciada.total)
          }

          this.totalStatus = itens
          itens.forEach(({ tipostatusplano, total }) => {
            this.model.por_status[tipostatusplano] = parseInt(total)
          })

          let inicial = 0
          this.model.total = itens.reduce(
            (acumulador, objeto) => acumulador + parseInt(objeto.total),
            inicial
          )
        },
        error => {
          console.log(error)
        }
      )
    },
    consultar() {
      if (!this.unidade) {
        return
      }

      this.totalStatusSecretaria = []
      this.model.totalSecretaria = null

      request.get(
        'sigsantos/totalTipo/' + this.unidade.iduorre,
        response => {
          let itens = []

          if (
            response.data
              .map(({ tipostatusplano }) => tipostatusplano)
              .includes('NÃO INICIADA') === false
          ) {
            itens = response.data
          } else {
            const itemNaoIniciada = response.data.find(
              i => i.tipostatusplano === 'NÃO INICIADA'
            )
            itens = response.data.filter(
              i => i.tipostatusplano != 'NÃO INICIADA'
            )
            const indexItemNaoCumprida = itens.findIndex(
              i => i.tipostatusplano === 'NÃO CUMPRIDA'
            )

            itens[indexItemNaoCumprida].total =
              parseInt(itens[indexItemNaoCumprida].total) +
              parseInt(itemNaoIniciada.total)
          }

          this.totalStatusSecretaria = itens

          itens.forEach(({ tipostatusplano, total }) => {
            this.model.por_status_secretaria[tipostatusplano] = parseInt(total)
          })

          let inicial = 0
          this.model.totalSecretaria = itens.reduce(
            (acumulador, objeto) => acumulador + parseInt(objeto.total),
            inicial
          )
        },
        error => {
          console.log(error)
        }
      )
    },
    loadTotais() {
      request.get(
        'sigsantos/totais',
        response => {
          const { planogoverno, prioridade, metas } = response

          planogoverno.naoConcluido += Number(planogoverno.naoInformado)
          delete planogoverno.naoInformado

          prioridade.naoConcluido += Number(prioridade.naoInformado)
          delete prioridade.naoInformado

          this.totais = { metas, planogoverno, prioridade }
        },
        response => {
          console.log(response)
        }
      )
    },
    loadTiposPlano() {
      request.get(
        'sigsantos/tiposplano',
        response => {
          this.tiposPlano = [{ codigo: 'todos', nome: 'Todos' }, ...response]
          this.tipoPlanoCodigo = this.tiposPlano[0].codigo
          this.getTipoPlanoData()
        },
        response => {
          console.log(response)
        }
      )
    },
    getTipoPlanoData() {
      if (!this.tipoPlanoCodigo) {
        return
      }

      request.get(
        `sigsantos/totalTipoPlano/${this.tipoPlanoCodigo}`,
        response => {
          // concatenar não cumprida com não iniciada
          if (response.indefinido > 0) {
            const { labels, data } = response.chartData
            const index = labels.findIndex(i => i === 'NÃO INICIADA')

            labels.splice(index, 1)
            data.splice(index, 1)

            response.chartData = { labels, data }
            response.naoConcluido += parseInt(response.indefinido)
          }
          delete response.indefinido

          this.tipoPlanoData = response
        },
        error => console.log(error)
      )
    },
    entidadeBySigla
  },
  mounted() {
    request.get(
      'sigsantos/rankCompromissos',
      response => {
        this.model.rank_compromissos = response.data
      },
      response => {
        console.log(response)
      }
    )

    this.totalPorTipo()
    this.loadRankingConcluidas()
    this.listarSecretarias()
    this.loadTotais()
    this.loadTiposPlano()
  }
}



// WEBPACK FOOTER //
// ./src/views/public/planos_municipal/app.js